export const integrationsEntitlement = 'sharefile:entitlementdef-integration-install';
export const solutionsEntitlement = 'sharefile:entitlementdef-solution-install';
export const templatesEntitlement = 'sharefile:entitlementdef-template-install';
